import GrantPermission from './GrantPermission'

export default GrantPermission
